import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent {
  
  @Input() showContainerUser: boolean = true;
  @Input() isAdmin?: boolean = false;
  @Input() userCompleteName: string = '';
  @Input() profileName: string = '';
  @Input() profileCompanyName: string = '';
  @Input() items: MenuItem[] = [];

  @Output() goToUserContactInfo = new EventEmitter()

  materialIconsReady: boolean = false;

  constructor(
    private readonly router: Router
  ) {}

  ngOnChanges() {
    if (this.items.length > 0) {
      this.expandSelectedSubitem(this.router.url)
    }
  }

  ngAfterViewInit() {
    document.fonts.ready.then(() => {
      this.materialIconsReady = true;
    });
  }

  expandSelectedSubitem(url: string) {
    this.items?.forEach((el: MenuItem) => {
      el.items?.forEach((item: MenuItem) => {
        if (this.validateUrl(item, url)) el.expanded = true;

        item.items?.forEach((innerItem: MenuItem) => {
          if (this.validateUrl(innerItem, url)) {
            el.expanded = true;
            item.expanded = true;
          }
        })
      })
    })
  }

  validateUrl(item: MenuItem, url: string) {
    if (item.routerLink?.[0]) {
      return ((item.fragment && `${item.routerLink[0]}#${item.fragment}` === url) || item.routerLink[0] === url)
    }
    return false
  }

  redirectToUserContactInfo() {
    this.goToUserContactInfo?.emit()
  }
}
